module.exports = __webpack_public_path__ + "media/images/ico-titles@2x-b9e46b27991f8e2dad117279bc89c072.png";